import { render, staticRenderFns } from "./chat-badge.vue?vue&type=template&id=75df5d36&scoped=true&"
import script from "./chat-badge.vue?vue&type=script&lang=js&"
export * from "./chat-badge.vue?vue&type=script&lang=js&"
import style0 from "./chat-badge.vue?vue&type=style&index=0&id=75df5d36&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75df5d36",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('75df5d36')) {
      api.createRecord('75df5d36', component.options)
    } else {
      api.reload('75df5d36', component.options)
    }
    module.hot.accept("./chat-badge.vue?vue&type=template&id=75df5d36&scoped=true&", function () {
      api.rerender('75df5d36', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/atendimento/components/chat-badge/chat-badge.vue"
export default component.exports